import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';

import { useBnplPromo } from './useBnplPromo';

export const useBnplBanner = () => {
  const router = useRouter();

  const bnplPromo = useBnplPromo();

  const [height, setHeight] = useState(0);
  const [isDismissed, setIsDismissed] = useState<boolean>();

  const elementRef = useRef(null);

  const isHome = router.pathname === '/';
  const showBanner = bnplPromo.isLoading || (isHome && bnplPromo.isEnabled);

  const bannerContainerStyle = {
    '--banner-height': `${height}px`,
  } as React.CSSProperties;

  const handleDismissBanner = () => {
    setIsDismissed(true);
    localStorage.setItem('dismissed-bnpl-banner', 'true');
  };

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];

      setHeight(entry.contentRect.height);
    });

    const currentElement = elementRef.current;

    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, []);

  useEffect(() => {
    const dismissed = localStorage.getItem('dismissed-bnpl-banner');

    if (dismissed === 'true') {
      setIsDismissed(true);
    } else {
      setIsDismissed(false);
    }
  }, []);

  return {
    height,
    elementRef,
    bannerContainerStyle,
    showBanner,
    isDismissed,
    onDismissBanner: handleDismissBanner,
    bnplCapabilities: bnplPromo.bnplCapabilities,
    isLoading: bnplPromo.isLoading,
  };
};
